export const shareLinkProposalReviewCopy = {
  en: {
    title: 'Review ShareLink change',
    description: 'Check the exact change and recipient policy before you decide.',
    loadError: 'This proposal could not be loaded. Check access or try again.',
    retry: 'Try again',
    back: 'Back to shares',
    proposedBy: 'Proposed by {{userId}}',
    status: {
      PENDING_REVIEW: 'Awaiting review',
      APPROVED: 'Approved',
      REJECTED: 'Rejected',
      EXPIRED: 'Expired',
    },
    action: {
      CREATE: 'Create a ShareLink',
      UPDATE: 'Update a ShareLink',
      REVOKE: 'Revoke a ShareLink',
    },
    name: 'Name',
    accessType: 'Access',
    expiry: 'Expires',
    recipients: 'Recipients',
    target: 'Current ShareLink',
    targetRevision: 'Current revision {{revision}}',
    allowedEmails: 'Allowed email addresses',
    recipientsRedacted: '{{count}} address(es) removed after the proposal ended',
    allowedUsers: 'Allowed user IDs',
    stale:
      'The Presentation, live Release, or ShareLink changed after this proposal was submitted. It cannot be approved.',
    unsupported: 'This operation is not supported by the current ShareLink proposal policy.',
    passwordNote:
      'Password changes are unavailable while the password policy is under review. Existing password values are never shown here.',
    decisionError: 'The decision could not be completed. The latest proposal state was reloaded.',
    decision: {
      approve: 'Approve and apply change',
      reject: 'Reject proposal',
      pending: 'Saving…',
    },
    confirmation: {
      title: 'Confirm this decision',
      approve:
        'Approval applies this ShareLink change immediately. Continue only after reviewing the details above.',
      reject: 'Rejecting closes this proposal without changing the ShareLink.',
      cancel: 'Cancel',
      confirm: 'Confirm decision',
    },
    decisionNotice:
      'Approval requires strong recent authentication. Your decision is checked again by Slider before it is applied.',
    decisionDone: 'Proposal decision saved.',
    revision: 'Review revision {{revision}}',
  },
  fa: {
    title: 'بازبینی تغییر پیوند اشتراک',
    description: 'پیش از تصمیم، تغییر دقیق و سیاست گیرندگان را بررسی کنید.',
    loadError: 'این پیشنهاد بارگیری نشد. دسترسی را بررسی کنید یا دوباره تلاش کنید.',
    retry: 'تلاش دوباره',
    back: 'بازگشت به اشتراک‌ها',
    proposedBy: 'پیشنهاددهنده: {{userId}}',
    status: {
      PENDING_REVIEW: 'در انتظار بازبینی',
      APPROVED: 'تأیید شد',
      REJECTED: 'رد شد',
      EXPIRED: 'منقضی شد',
    },
    action: {
      CREATE: 'ایجاد پیوند اشتراک',
      UPDATE: 'به‌روزرسانی پیوند اشتراک',
      REVOKE: 'لغو پیوند اشتراک',
    },
    name: 'نام',
    accessType: 'دسترسی',
    expiry: 'تاریخ انقضا',
    recipients: 'گیرندگان',
    target: 'پیوند اشتراک فعلی',
    targetRevision: 'نسخهٔ فعلی {{revision}}',
    allowedEmails: 'نشانی‌های ایمیل مجاز',
    recipientsRedacted: '{{count}} نشانی پس از پایان پیشنهاد حذف شد',
    allowedUsers: 'شناسه‌های کاربر مجاز',
    stale:
      'ارائه، نسخهٔ زنده یا پیوند اشتراک پس از ثبت پیشنهاد تغییر کرده است؛ امکان تأیید وجود ندارد.',
    unsupported: 'این عملیات در سیاست فعلی پیشنهادهای اشتراک پشتیبانی نمی‌شود.',
    passwordNote:
      'تغییر گذرواژه تا زمان بررسی سیاست در دسترس نیست. مقدار گذرواژهٔ فعلی هرگز نمایش داده نمی‌شود.',
    decisionError: 'تصمیم ثبت نشد. آخرین وضعیت پیشنهاد دوباره بارگیری شد.',
    decision: { approve: 'تأیید و اعمال تغییر', reject: 'رد پیشنهاد', pending: 'در حال ذخیره…' },
    confirmation: {
      title: 'تأیید تصمیم',
      approve:
        'با تأیید، این تغییر پیوند اشتراک فوراً اعمال می‌شود. پس از بررسی جزئیات ادامه دهید.',
      reject: 'با رد پیشنهاد، بدون تغییر پیوند اشتراک بسته می‌شود.',
      cancel: 'انصراف',
      confirm: 'تأیید تصمیم',
    },
    decisionNotice:
      'تأیید به احراز هویت قوی و تازه نیاز دارد. Slider پیش از اعمال، دسترسی و وضعیت را دوباره بررسی می‌کند.',
    decisionDone: 'تصمیم پیشنهاد ذخیره شد.',
    revision: 'نسخهٔ بازبینی {{revision}}',
  },
} as const;
